import { render, staticRenderFns } from "./DataDivider.vue?vue&type=template&id=0375995f"
import script from "./DataDivider.vue?vue&type=script&lang=js"
export * from "./DataDivider.vue?vue&type=script&lang=js"
import style0 from "./DataDivider.vue?vue&type=style&index=0&id=0375995f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports